import { Backdrop, Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAddSchedule } from "../../../../api/effects/mutations/Kandidat/addSchedule";
import { useEditSchedule } from "../../../../api/effects/mutations/Kandidat/editSchedule";
import { useFetchKandidat } from "../../../../api/effects/mutations/Kandidat/useFetchKandidat";
import InputDateTime from "../../../../components/InputDateTime";
import InputSelect from "../../../../components/InputSelect";
import InputTextField from "../../../../components/InputTextField";
import { toIsoStringDateTime } from "../../../../utils/dateConvert";
import InputMultipleSelect from "../../../../components/InputMultipleSelect";
import useFetchAllInterviewer from "../../../../api/effects/queries/Kandidat/useFetchAllInterviewer";
import { InterviewerResponse } from "../../../../models/Kandidat";
import LoadingScreen from "../../../../components/LoadingScreen";
import { WarningModal } from "../../../../components/WarningModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "45%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    padding: "10px",
  },
  margin: "1%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
}));

const ScrollGrid = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  maxHeight: "90vh",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "11%",
  paddingTop: "1vh",
}));

type Props = {
  open: boolean;
  handleClose: () => void;
  ID?: number;
};

export default function KandidatModal({ ID = -1, open, handleClose }: Props) {
  const [tanggalInterview, setTanggalInterview] = useState(
    toIsoStringDateTime(Date.now())
  );
  const [tempatInterview, setTempatInterview] = useState("");
  const [alamatInterview, setAlamatInterview] = useState("");
  const [interviewers, setInterviewers] = useState<number[]>([]);
  const [status, setStatus] = useState("");
  const [kandidat, setKandidat] = useState("");
  const [job, setJob] = useState("");
  const [warningModal, setWarningModal] = useState(false);
  const [warningText, setWarningText] = useState("");

  const { data: allInterviewerData } = useFetchAllInterviewer();
  const [selectionData, setSelectionData] = useState<InterviewerResponse[]>([]);

  useEffect(() => {
    if (allInterviewerData !== undefined) {
      setSelectionData(allInterviewerData);
    }
  }, [allInterviewerData]);

  const { mutateAsync: GetKandidatData } = useFetchKandidat({
    onSuccess(data) {
      setStatus(data.STATUS_KANDIDAT);
      if (data.TANGGAL_INTERVIEW !== null) {
        setTanggalInterview(toIsoStringDateTime(data.TANGGAL_INTERVIEW));
      }
      if (data.TEMPAT_INTERVIEW !== null) {
        setTempatInterview(data.TEMPAT_INTERVIEW);
      }
      if (data.ALAMAT_INTERVIEW !== null) {
        setAlamatInterview(data.ALAMAT_INTERVIEW);
      }
      setKandidat(data.NAMA);
      setJob(data.JOB);
      setInterviewers(data.INTERVIEWERS.map(Number));
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  useEffect(() => {
    if (ID > 0) {
      GetKandidatData(ID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleTanggalInterview = (e: any) => {
    setTanggalInterview(e);
  };

  const handleTempatInterview = (e: any) => {
    setTempatInterview(e.target.value);
  };

  const handleAlamatInterview = (e: any) => {
    setAlamatInterview(e.target.value);
  };

  const handleInterviewers = (e: any) => {
    console.log(e.target.value);
    setInterviewers(e.target.value);
  };

  const handleSave = () => {
    if (status === "New") {
      AddSchedule({
        KANDIDAT_ID: ID,
        TANGGAL_INTERVIEW: toIsoStringDateTime(tanggalInterview),
        TEMPAT_INTERVIEW: tempatInterview,
        ALAMAT_INTERVIEW: alamatInterview,
        INTERVIEWERS: interviewers,
      });
    } else {
      EditSchedule({
        KANDIDAT_ID: ID,
        TANGGAL_INTERVIEW: toIsoStringDateTime(tanggalInterview),
        TEMPAT_INTERVIEW: tempatInterview,
        ALAMAT_INTERVIEW: alamatInterview,
        INTERVIEWERS: interviewers,
      });
    }
  };

  const handleWarningModal = () => {
    setWarningModal(false);
    handleClose();
  };

  const { mutateAsync: EditSchedule, isLoading: isEditLoading } =
    useEditSchedule({
      onSuccess(response) {
        setWarningText(response);
        setWarningModal(true);
      },
      onError() {
        setWarningText("Error");
        setWarningModal(true);
      },
    });

  const { mutateAsync: AddSchedule, isLoading: isAddLoading } = useAddSchedule({
    onSuccess(response) {
      setWarningText(response);
      setWarningModal(true);
    },
    onError() {
      setWarningText("Error");
      setWarningModal(true);
    },
  });

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <WarningModal
        open={warningModal}
        handleClose={handleWarningModal}
        text={warningText}
      />
      <LoadingScreen open={isAddLoading || isEditLoading} />
      <SquareGrid container>
        <ScrollGrid container>
          <Grid container justifyContent="flex-start" paddingLeft={"10.5%"} item xs={6}
            paddingBottom={
              {
                xs: 5,
                sm: 5,
                md: 5,
                lg: 5,
                xl: 5
              }}>
            <Typography variant="subtitle1" color="black">
              {status === "New"
                ? "Schedule Interview"
                : "Re-Schedule Interview"}
            </Typography>
          </Grid>
          <TitleGrid container justifyContent="flex-end" item xs={6}>
            <Button onClick={handleClose}>Close</Button>
          </TitleGrid>
          <TitleGrid container item xs={12}>
            <Grid item xs={12}>
              <Typography color="black" variant="h6">
                Kandidat :
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="black">{kandidat}</Typography>
            </Grid>
          </TitleGrid>

          <TitleGrid container item xs={12}>
            <Grid item xs={12}>
              <Typography color="black" variant="h6">
                Job :
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="black">{job}</Typography>
            </Grid>
          </TitleGrid>
          <InputSelect
            title={"Tempat Interview"}
            selection={[
              { value: "Offline", text: "Offline" },
              { value: "Online", text: "Online" },
            ]}
            value={tempatInterview}
            handleEdit={handleTempatInterview}
          />
          <InputTextField
            title={"Alamat Interview"}
            value={alamatInterview}
            handleEdit={handleAlamatInterview}
          />
          <InputDateTime
            title={"Tanggal Interview (WIB)"}
            value={tanggalInterview}
            handleEdit={handleTanggalInterview}
          />
          <InputMultipleSelect
            title={"Interviewers"}
            selection={selectionData}
            value={interviewers}
            handleEdit={handleInterviewers}
          />
          <Grid container justifyContent="center" item xs={12}>
            <FullButton variant="contained" onClick={handleSave}>
              Save
            </FullButton>
          </Grid>
        </ScrollGrid>
      </SquareGrid>
    </Backdrop>
  );
}
